import { useState, useEffect } from 'react';
import { Paper } from '@mui/material';
import SearchChildByParentID from '../components/molecules/SearchChildByParentId';
import UploadController from '../components/UploadController';
import ChildIndicatorContainer from '../components/organisms/ChildIndicatorContainer';
import PageHeader from '../components/molecules/PageHeader';

const Upload = () => {
  const [parentInfo, setParentInfo] = useState({});
  const [parentFound, setParentFound] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState();

  useEffect(() => {
    if (parentInfo.parent_id === null) return;
    if (Object.keys(parentInfo).length > 0) setParentFound(1);
    setSelectedStudent(parentInfo?.students?.[0]);
  }, [parentInfo]);

  // COMPONENT OUTPUT
  return (
    <div>
      <PageHeader testid='upload-title'>Upload Documents</PageHeader>

      <Paper elevation={5} sx={{ padding: '20px' }}>
        <div>
          Please SCAN all documents using a phone scanner or desktop scanner.
          <br />
          Max Document Size: 5MB Accepted formats: JPG or PDF
        </div>
        <div className='spacer'></div>

        {parentFound ? (
          <div>
            <div data-cy='user-detail-container' className='pb-4'>
              <div>
                Parent:
                <span className='sectionHeader' data-cy='parent-name'>
                  {parentInfo?.parent_name ?? 'Not Found'}
                </span>
              </div>
              <div className='spacer'></div>

              <ChildIndicatorContainer
                studentArray={parentInfo.students}
                setter={setSelectedStudent}
              />
            </div>

            <div style={{ backgroundColor: '#eee', padding: '10px' }}>
              <span className='text-lg font-light'>
                Upload documents for:{' '}
                <span className='font-bold' data-cy='child-uploading-name'>
                  {selectedStudent?.name}
                </span>
              </span>
            </div>
            <div className='spacer'></div>
            <UploadController studentId={selectedStudent.id} />
          </div>
        ) : (
          <SearchChildByParentID
            searchInfoSetter={setParentInfo}
            label='
            To proceed, please enter the registered email address that was registered previously:
            '
          />
        )}

        <div className='spacer'></div>
      </Paper>
    </div>
  );
};

export default Upload;
